<template>
    <div class="card w-100">
        <div class="card-body d-flex flex-column">
            <div class="trip-summary-header mb-4 flex-grow-1">
                <!--TODO use trip name for group instead.-->
                <h3 v-if="tripType === 'GROUP' || departureAirport === undefined || arrivalAirport === undefined">
                    {{trip.name}}
                </h3>
                <div v-else>
                    <h3>
                        {{departureAirport.city}} ({{departureAirport.iata}})
                        <font-awesome-icon class="mx-2" :icon="['fal', 'plane']" />
                        {{arrivalAirport.city}} ({{arrivalAirport.iata}})
                    </h3>
                    <div class="lead row g-0">
                        <div class="col-md-auto">
                            {{$filters.beautifyDate(trip.travelDateFrom)}} <span v-if="trip.travelDateFrom !== trip.travelDateTo">&ndash; {{$filters.beautifyDate(trip.travelDateTo)}}</span>
                            <span class="d-none d-md-inline-block">&nbsp;&nbsp;&bull;&nbsp;&nbsp;</span>
                        </div>
                        <div class="col-md-auto">
                            {{$t(`common.tripType.${trip.pnr.tripType}`)}}&nbsp;&nbsp;&bull;&nbsp;&nbsp;
                            {{$t(`common.cabinClass.${trip.pnr.highestCabinClass}`)}}
                        </div>
                    </div>
                </div>
            </div>
            <accent-box :title="$t('common.tripSummary.yourTripSummary')" class="trip-summary">
                <div class="row">
                    <div v-if="tripType === 'INDIVIDUAL' && trip.pnr.recordLocator" class="col-12 col-md-6 border-md-end py-1">
                        <div class="row">
                            <div class="col-5">
                                {{$t('common.tripSummary.tripReference')}}
                            </div>
                            <div class="col-7">
                                <strong>{{trip.pnr.recordLocator}}</strong>
                            </div>
                        </div>
                    </div>
                    <div v-if="validatingAirline !== undefined" class="col-12 col-md-6 py-1">
                        <div class="row">
                            <div class="col-5">
                                {{$t('common.tripSummary.airline')}}
                            </div>
                            <div class="col-7 d-flex align-items-center">
                                <img :src="validatingAirline.logoUrlSmall" :alt="validatingAirline.name" class="airline-logo-sm me-1"/>
                                <strong>{{validatingAirline.name}}</strong>
                            </div>
                        </div>
                    </div>
                    <div v-if="trip.cityPairs" class="col-12 col-md-6 border-md-end py-1">
                        <div class="row">
                            <div class="col-5">
                                {{$t('common.tripSummary.cities')}}
                            </div>
                            <div class="col-7">
                                <strong>{{trip.cityPairs}}</strong>
                            </div>
                        </div>
                    </div>
                    <div v-if="tripType === 'INDIVIDUAL'" class="col-12 col-md-6 py-1">
                        <div class="row">
                            <div class="col-5">
                                {{$t('common.tripSummary.travelers')}}
                            </div>
                            <div class="col-7">
                                <strong>{{trip.pnr.travelers.length}}</strong>
                            </div>
                        </div>
                    </div>
                    <div v-if="trip.confirmationDate" class="col-12 col-md-6 border-md-end py-1">
                        <div class="row">
                            <div class="col-5">
                                {{$t('common.tripSummary.dateReserved')}}
                            </div>
                            <div class="col-7">
                                <strong>{{$filters.beautifyDate(trip.confirmationDate)}}</strong>
                            </div>
                        </div>
                    </div>
                    <div v-if="trip.travelDateFrom" class="col-12 col-md-6 py-1">
                        <div class="row">
                            <div class="col-5">
                                {{$t('common.tripSummary.travelDate')}}
                            </div>
                            <div class="col-7">
                                <strong>{{$filters.beautifyDate(trip.travelDateFrom)}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </accent-box>
        </div>
    </div>
</template>

<script>
import AccentBox from "@/components/common/AccentBox";
export default {
    name: 'TripSummary',
    components: {AccentBox},
    props: {
        trip: {
            type: Object,
            required: true
        }
    },
    computed: {
        tripType() {
            return this.trip.group || !this.trip.pnr ? 'GROUP' : 'INDIVIDUAL';
        },
        validatingAirline() {
            //This is an Individual trip field only.
            if(this.tripType !== 'INDIVIDUAL') return undefined;

            return Object.values(this.trip.pnr.airlines).find(airline => airline.iata === this.trip.pnr.validatingAirlineCode);
        },
        departureAirport() {
            //This is an Individual trip field only.
            if(this.tripType !== 'INDIVIDUAL') return undefined;

            return Object.values(this.trip.pnr.airports).find(airport => airport.iata === this.trip.pnr.originDestinations[0].departureAirportCode);
        },
        arrivalAirport() {
            //This is an Individual trip field only.
            if(this.tripType !== 'INDIVIDUAL') return undefined;

            return Object.values(this.trip.pnr.airports).find(airport => airport.iata === this.trip.pnr.originDestinations[0].arrivalAirportCode);
        }
    }

};
</script>

<style lang="scss" scoped>
    .airline-logo-sm {
        height: 1.25rem;
    }
    @include media-breakpoint-down(lg) {
        .trip-summary-header {
            h3 {
                font-size: 1.25rem;
            }
            h4 {
                font-size: 1.0rem;
            }
            .lead {
                font-size: 1.0rem;
            }
        }
    }
</style>